// Fetches the 8-day forward window of events for the calendar block's
// auto-pull mode. Refreshes on window focus so the editor reflects
// events added on the Events page in another tab.

import { useCallback, useEffect, useState } from 'react';
import { eventsApi } from '../lib/api';
import { todayIso, addDays } from '@shared/event-date';
import type { EventListItem } from '@shared/types';

export function useUpcomingEvents() {
  const [events, setEvents] = useState<EventListItem[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const today = todayIso();
      const to = addDays(today, 7); // today + 7 = 8 days inclusive
      const { events } = await eventsApi.list({ from: today, to, include_hidden: false });
      setEvents(events);
    } catch {
      // Silent fallback to empty so the calendar block still renders.
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh]);

  return { events, loading, refresh };
}
